// styles.js
export const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#EEF2F7',
  },

  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '24px 16px',
  },

  header: {
    backgroundColor: '#0B3A5B',
    borderRadius: 12,
    padding: '22px 18px',
    color: '#fff',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  },

  headerTop: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },

  title: {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: 0.2,
  },

  subtitle: {
    marginTop: 6,
    fontSize: 13,
    opacity: 0.9,
  },

  headerBottom: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 14,
  },

  counterPill: {
    backgroundColor: 'rgba(255,255,255,0.14)',
    border: '1px solid rgba(255,255,255,0.22)',
    padding: '6px 10px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
  },

  progressTrack: {
    marginTop: 12,
    height: 8,
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.20)',
    overflow: 'hidden',
  },

  progressFill: (pct) => ({
    width: `${Math.max(0, Math.min(100, pct || 0))}%`,
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#22C55E',
  }),

  body: {
    marginTop: 16,
  },

  alertError: {
    backgroundColor: '#FEE2E2',
    border: '1px solid #FCA5A5',
    padding: 12,
    borderRadius: 10,
    marginBottom: 12,
  },

  alertSuccess: {
    backgroundColor: '#DCFCE7',
    border: '1px solid #86EFAC',
    padding: 12,
    borderRadius: 10,
    marginBottom: 12,
  },

  card: {
    backgroundColor: '#fff',
    borderRadius: 14,
    padding: 16,
    border: '1px solid #E5E7EB',
    boxShadow: '0 10px 30px rgba(17,24,39,0.06)',
  },

  formGrid: (isMobile) => ({
    marginTop: 14,
    display: 'grid',
    gap: 12,
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
  }),

  grid: (isMobile) => ({
    display: 'grid',
    gap: 14,
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    alignItems: 'start',
  }),

  questionCard: (ok) => ({
    backgroundColor: '#fff',
    borderRadius: 14,
    padding: 16,
    border: ok ? '1px solid #86EFAC' : '1px solid #E5E7EB',
    boxShadow: '0 10px 30px rgba(17,24,39,0.06)',
  }),

  qTop: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    marginBottom: 12,
  },

  qNumber: {
    minWidth: 28,
    height: 28,
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F3F4F6',
    color: '#111827',
    fontSize: 12,
    fontWeight: 800,
  },

  qText: {
    fontSize: 14,
    fontWeight: 800,
    color: '#111827',
    lineHeight: 1.25,
    wordBreak: 'break-word',
  },

  boolRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },

  boolBtn: (active) => ({
    border: active ? '1px solid #1D4ED8' : '1px solid #D1D5DB',
    backgroundColor: active ? '#EFF6FF' : '#fff',
    color: active ? '#1D4ED8' : '#111827',
    borderRadius: 10,
    padding: '10px 12px',
    cursor: 'pointer',
    fontWeight: 800,
    fontSize: 13,
  }),

  textarea: {
    width: '100%',
    minHeight: 120,
    resize: 'vertical',
    borderRadius: 12,
    padding: 12,
    border: '1px solid #D1D5DB',
    outline: 'none',
    fontSize: 14,
  },

  fileRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    padding: 10,
  },

  clearBtn: {
    border: 'none',
    backgroundColor: '#111827',
    color: '#fff',
    borderRadius: 10,
    padding: '8px 10px',
    cursor: 'pointer',
    fontWeight: 800,
    fontSize: 12,
  },

  footer: {
    position: 'sticky',
    bottom: 0,
    marginTop: 16,
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    padding: 12,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 10px 30px rgba(17,24,39,0.08)',
  },

  leftFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },

  rightFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },

  missing: {
    color: '#6B7280',
    fontSize: 13,
    fontWeight: 700,
  },

  topInner: (isMobile) => ({
    width: '100%',
    padding: isMobile ? '10px 12px' : '10px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),

  logo: {
    width: 150,
    height: 'auto',
    userSelect: 'none',
  },

  headerArea: (isMobile) => ({
    width: '100%',
    padding: isMobile ? '22px 12px 14px' : '26px 24px 18px',
  }),

  headerRow: (isMobile) => ({
    display: 'flex',
    alignItems: isMobile ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexDirection: isMobile ? 'column' : 'row',
  }),

  headerTitle: {
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: 20,
    lineHeight: 1.2,
  },

  headerSub: {
    marginTop: 4,
    color: 'rgba(255,255,255,0.85)',
    fontWeight: 600,
    fontSize: 12,
  },

  counterPillTop: {
    alignSelf: 'flex-start',
    padding: '6px 10px',
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.12)',
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: 12,
    whiteSpace: 'nowrap',
  },

  progressTrackTop: {
    marginTop: 10,
    height: 6,
    borderRadius: 999,
    backgroundColor: 'rgba(255,255,255,0.18)',
    overflow: 'hidden',
  },

  progressFillTop: (pct) => ({
    height: '100%',
    width: `${Math.max(0, Math.min(100, pct))}%`,
    backgroundColor: 'rgba(255,255,255,0.70)',
    borderRadius: 999,
  }),

  qDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#D1D5DB',
    marginTop: 10,
    marginBottom: 0,
  },

  messageWrap: () => ({
    width: '100%',
    marginBottom: 14,
  }),

  messageBox: (type = 'info') => {
    const base = {
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'center',
      padding: '10px 14px',
      borderRadius: 10,
      fontWeight: 700,
    };

    if (type === 'error') return { ...base, background: '#FEF2F2', border: '1px solid #FCA5A5' };
    if (type === 'success') return { ...base, background: '#ECFDF5', border: '1px solid #86EFAC' };
    return { ...base, background: '#F3F4F6', border: '1px solid #E5E7EB' };
  },

  successScreen: (isMobile) => ({
    minHeight: isMobile ? 'calc(100vh - 185px)' : 'calc(100vh - 205px)',
    padding: isMobile ? '24px 0' : '48px 0',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  successCard: (isMobile) => ({
    width: '100%',
    maxWidth: 560,
    minHeight: isMobile ? 230 : 260,
    padding: isMobile ? '32px 20px' : '40px 32px',
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    borderRadius: 16,
    boxShadow: '0 12px 32px rgba(17,24,39,0.08)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    textAlign: 'center',
  }),

  successIcon: {
    width: 72,
    height: 72,
    borderRadius: 999,
    backgroundColor: '#ECFDF5',
    color: '#059669',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 4,
  },

  successTitle: (isMobile) => ({
    color: '#111827',
    fontSize: isMobile ? 20 : 22,
    fontWeight: 800,
    lineHeight: 1.3,
  }),

  successDescription: (isMobile) => ({
    color: '#6B7280',
    fontSize: isMobile ? 14 : 15,
    lineHeight: 1.5,
  }),

  gridMaxWidth: (cols, isMobile) => {
    const minCard = 320;
    const gap = isMobile ? 12 : 16;
    if (cols === 1) return minCard;
    if (cols === 2) return minCard * 2 + gap;
    return minCard * 3 + gap * 2;
  },
};
